<script setup lang="ts">
defineProps<{
  color?: any
}>()
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    :style="color"
    class="eb-icon-nosize w-10 h-10 p-1"
  >
    <path
      d="M11.159,33.807c-9.006-3.503-13.466-13.64-9.966-22.647C4.696,2.153,14.837-2.31,23.841,1.196
c9.006,3.498,13.466,13.642,9.966,22.645C30.304,32.849,20.163,37.308,11.159,33.807"
    />
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 520 520">
      <ellipse stroke-width="17" ry="220" rx="219" id="svg_1" cy="260" cx="260" stroke="#fff" fill="none"/>
  <ellipse stroke="#fff" stroke-width="65" ry="105" rx="105" id="svg_6" cy="260" cx="260" fill="none"/>
  <path transform="rotate(-89.955 347.482 259.72)" stroke="currentColor" id="svg_8" d="m315.73701,285.20997l31.74531,-50.97964l31.74531,50.97964l-65.49062,4z" stroke-width="62" fill="#000"/>
    </svg>
  </svg>
</template>